import React, { useEffect, useRef, useState } from 'react';
import './file-card.scss';
import { SVGS } from '../../assets';

interface FileCardProps {
  deleteFile: () => void;
  downloadFile: () => void;
  fileName: string;
  viewFile: () => void;
}

export const FileCard: React.FC<FileCardProps> = ({
  deleteFile,
  downloadFile,
  fileName,
  viewFile,
}) => {
  const menuRef = useRef<HTMLDivElement>(null);
  const [openMenu, setOpenMenu] = useState<boolean>(false);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setOpenMenu(false);
      }
    };

    if (openMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [openMenu]);

  return (
    <div className="file-card">
      <img src={SVGS.Document} alt="" className="file-card-icon" />
      <div className="file-card-data">
        <span className="file-card-data-heading primary-font-regular">
          {fileName}
        </span>
      </div>
      <div className="file-card-more">
        <img
          src={SVGS.MoreIcon}
          alt=""
          className={`file-card-more-icon ${openMenu ? 'open-menu' : ''}`}
          onClick={() => setOpenMenu(!openMenu)}
        />
        {openMenu && (
          <div
            className="file-card-more-menu"
            ref={menuRef}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <div
              className="file-card-more-menu-item view-option primary-font-regular"
              onClick={() => {
                viewFile();
                setOpenMenu(false);
              }}
            >
              <img
                src={SVGS.EyeIcon}
                alt=""
                className="file-card-more-menu-item-icon"
              />
              <span className="file-card-more-menu-item-text">View</span>
            </div>
            <div
              className="file-card-more-menu-item download-option primary-font-regular"
              onClick={() => {
                downloadFile();
                setOpenMenu(false);
              }}
            >
              <img
                src={SVGS.EyeIcon}
                alt=""
                className="file-card-more-menu-item-icon"
              />
              <span className="file-card-more-menu-item-text">Download</span>
            </div>
            <div
              className="file-card-more-menu-item delete-option primary-font-regular"
              onClick={() => {
                deleteFile();
                setOpenMenu(false);
              }}
            >
              <img
                src={SVGS.DeleteIcon}
                alt=""
                className="file-card-more-menu-item-icon"
              />
              <span className="file-card-more-menu-item-text">Delete</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
